import { useMemo } from 'react';
import cn from 'classnames';
import isMobileDevice from 'is-mobile';
import { AnchorLogo } from 'seagull/icons';
import styles from "./UnauthorizedPageContainer.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function UnauthorizedPageContainer(props) {
  const {
    testId,
    wideLayout,
    children,
    animatedBackground = true,
    hideBanner = false,
    otpLayout = false
  } = props;
  const {
    mp4Name,
    posterName
  } = useMemo(() => isMobileDevice() ? {
    mp4Name: 'Anchor_Mobile_Asset.mp4',
    posterName: '619225327129c80f56875d9f_Anchor_Mobile_Asset.jpg'
  } : {
    mp4Name: 'Anchor_Header.mp4',
    posterName: '6192253394e4106ddbeb5bdc_Anchor_Web_Asset.jpg'
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.unauthorizedPageContainer, otpLayout && styles.otpLayout),
    "data-testid": testId,
    children: [animatedBackground && /*#__PURE__*/_jsx("video", {
      className: styles.video,
      loop: true,
      muted: true,
      autoPlay: true,
      playsInline: true,
      width: "100%",
      src: "https://mtcdn.co/Anchor/".concat(mp4Name),
      poster: "https://assets.website-files.com/618126a3584667ecd40daf91/".concat(posterName),
      "data-testid": "unauthorized-page-background-animation"
    }), !hideBanner ? /*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [/*#__PURE__*/_jsx(AnchorLogo, {
        className: styles.logo
      }), /*#__PURE__*/_jsx("div", {
        "data-testid": "unauthorized-page-title",
        className: styles.title,
        children: "Do Business. Not Billing."
      }), /*#__PURE__*/_jsx("div", {
        "data-testid": "unauthorized-page-subtitle",
        className: styles.subTitle,
        children: "Get ready to get paid on time, every time. Automatically."
      })]
    }) : /*#__PURE__*/_jsx("div", {
      className: cn(otpLayout && styles.headerSpacer)
    }), /*#__PURE__*/_jsx("div", {
      className: cn(styles.formWrapper, otpLayout && styles.otpLayout),
      children: /*#__PURE__*/_jsx("div", {
        className: cn(styles.formCard, wideLayout && styles.wide, otpLayout && styles.otpLayout),
        children: children
      })
    }), /*#__PURE__*/_jsxs("footer", {
      className: styles.footer,
      children: [/*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: "https://www.sayanchor.com/privacy-policy",
        children: "Privacy Policy"
      }), /*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: "https://www.sayanchor.com/terms-of-contact",
        children: "Terms of Service"
      }), /*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: "https://www.sayanchor.com/data-privacy",
        children: "Data Privacy"
      })]
    })]
  });
}